export interface PermitInspection {
  id: string;
  type: 'mid-roof' | 'final' | 'reinspection' | 'other';
  scheduled_at: string;           // ISO
  inspector: string | null;
  result: 'pending' | 'pass' | 'fail' | 'conditional_pass';
  corrections: string | null;     // text — what needs to be fixed
  notes: string | null;           // free-text notes
  completed_at: string | null;    // ISO, when the inspector recorded the result
}

export interface Permit {
  id: string;
  job_id: string;
  jurisdiction_playbook_id: string | null;
  jurisdiction_name: string | null;
  jurisdiction_type: string | null;
  status: PermitStatus;
  permit_number: string | null;
  permit_portal_url: string | null;
  parcel_number: string | null;
  filed_at: string | null;
  approved_at: string | null;
  closed_at: string | null;
  required_documents: string[];
  uploaded_documents: Array<{ name: string; url: string; uploaded_at: string; uploaded_by?: string }>;
  inspections: PermitInspection[];
  fee_amount: number | null;
  fee_paid: boolean;
  fee_paid_at: string | null;
  assigned_to_id: string | null;
  assigned_to_name: string | null;
  notes: string | null;
  timeline_log: Array<{ action: string; actor: string; actor_id?: string; timestamp: string; note?: string }>;
  created_at: string;
  updated_at: string;
}

export type PermitStatus =
  | 'not_started' |'needs_filing' |'filed' |'pending_review' |'approved' |'scheduled_inspection' |'passed' |'failed' |'corrections_required' |'closed' |'not_required';

// Pipeline columns — the kanban lanes, in left-to-right order
export const PIPELINE_STAGES: Array<{ key: PermitStatus; label: string; dotColor: string; bg: string; text: string }> = [
  { key: 'needs_filing',         label: 'Needs Filing',  dotColor: '#dc2626', bg: 'bg-red-50',    text: 'text-red-700' },
  { key: 'filed',                label: 'Filed',         dotColor: '#2563eb', bg: 'bg-blue-50',   text: 'text-blue-700' },
  { key: 'pending_review',       label: 'Under Review',  dotColor: '#F5A623', bg: 'bg-amber-50',  text: 'text-amber-700' },
  { key: 'corrections_required', label: 'Corrections',   dotColor: '#dc2626', bg: 'bg-red-50',    text: 'text-red-700' },
  { key: 'approved',             label: 'Approved',      dotColor: '#16a34a', bg: 'bg-green-50',  text: 'text-green-700' },
  { key: 'scheduled_inspection', label: 'Inspection',    dotColor: '#7c3aed', bg: 'bg-purple-50', text: 'text-purple-700' },
  { key: 'passed',               label: 'Passed',        dotColor: '#16a34a', bg: 'bg-green-50',  text: 'text-green-700' },
  { key: 'closed',               label: 'Closed',        dotColor: '#6b7280', bg: 'bg-gray-50',   text: 'text-gray-600' },
];
